export default {
  verifications: {
    modal: 'verifications',
    path: '/verifications',
    auth: true,
    title: {
      ru: 'Верификация',
      ua: 'Веріфікація',
    },
  },
  verificationsBankId: {
    modal: 'verifications-bankid',
    auth: true,
  },
  verificationsDiia: {
    modal: 'verifications-diia',
    auth: true,
  },
  verificationsDocument: {
    modal: 'verifications-document',
    auth: true,
  },
  verificationsDocumentSelect: {
    modal: 'verifications-document-select',
    auth: true,
  },
  verificationsEmail: {
    modal: 'verifications-email',
    auth: true,
  },
  verificationsKycaid: {
    modal: 'verifications-kycaid',
    auth: true,
  },
  verificationsLimits: {
    modal: 'verifications-limits',
    auth: true,
  },
  verificationsPhone: {
    modal: 'verifications-phone',
    auth: true,
  },
}
